import { DeviceCard } from 'mobily-ui-library/lib'
import { t } from 'i18next'
import './Device.scss'

const Device = props => {
  const win = window
  const localhost = win.location.hostname === 'localhost'
  
  const serverURL = localhost ? 'http://ssta004:8080' : win.location.origin

  const onCardClick = () => {
    win.location.href = serverURL + props.data.pageUrl
  }

  return (
    <DeviceCard
      data={props.data}
      title={props.data.title}
      preOrderTag={ props.data.preorder === true ? t('preOrder') : ''}
      price={`${t('from')}  ${props.data.Price}  ${t('SAR')}`}
      deviceManufacturer={props.data.DeviceManufacturer}
      image={localhost ? serverURL + props.data.image : props.data.image}
      onCardClick={onCardClick}
    />
  )
}
export default Device
